import { render, staticRenderFns } from "./balance-update-query.vue?vue&type=template&id=6b0e6a3c"
import script from "./balance-update-query.vue?vue&type=script&lang=ts"
export * from "./balance-update-query.vue?vue&type=script&lang=ts"
import style0 from "./balance-update-query.vue?vue&type=style&index=0&id=6b0e6a3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports